import React, { useEffect, useState, useRef } from "react";
import { Grid } from '@mui/material';
import MuiTypography from '@mui/material/Typography';
import MaterialTable from "@material-table/core";
import MainCard from '../../ui-component/cards/MainCard';
import SecondaryAction from '../../ui-component/cards/CardSecondaryAction';
import { gridSpacing } from '../../store/constant';
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Flatpickr from "react-flatpickr";
import { Link } from "react-router-dom";
import { Label } from "reactstrap";
import pulse from "../../assets/images/icons/pulse.png";
import bill from "../../assets/images/icons/bill.png";
import bin from "../../assets/images/icons/bin_red.png";
import report from "../../assets/images/icons/report.png";
import tt from "../../assets/images/icons/tt.png";
import damage from "../../assets/images/icons/damage.png";
import moment from 'moment';
import { IconDownload, IconUpload } from '@tabler/icons';
import axiosInstance from '../../axiosInstance';
import { useSelector } from "react-redux";


const icons = {
     IconDownload,
     IconUpload
 };



const columns = [
     { title: "Sr. No.", field: "id" },
     { title: "File Name", field: "file_name" },
     { title: "", render: (rowData) => (
                         <button className="fp_w_alp__vrb__button override" style={{  }} onClick={() => handleButtonClick(rowData)}>
                              Preview File
                         </button>
                    ), 
     },
    
];

const handleButtonClick = (data)=>{
     console.log(data);

     if (data.file_url) {
          // const url = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,https://docs.google.com/spreadsheets/d/1iUmNaYboS0MDd-RlCtmiH1x5nb8kpNyGm-o0aYTKP44/edit#gid=891834841`;
          const splitedUrl = data.file_url.split("?")[0]
          const url = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${splitedUrl}`;
          const newWindow = window.open(url, '_blank');
          if (newWindow) {
               newWindow.focus();
          }
          // window.open(data.file_url, '_blank');
     }
}

function Master() {

     const [loading, setLoading] = useState(false);
     const [apiData, setAPIData] = useState([]);
     const [count, setCount] = useState(0);
     const org_id = useSelector((state) => state?.account?.org?.id);
     const user_email = useSelector((state) => state?.account?.user?.email);

     const getData = async () => {
          setLoading(true);
          try {
               const res = await fetch(`https://api.projectivetech.com/master/uploaded_csv_data/?format=json`, {
                    headers: {
                         'Content-Type': 'application/json'
                    }
               });
               // const res = await fetch(`http://127.0.0.1:8000//master/uploaded_csv_data/?format=json`, {
               //      headers: {
               //           'Content-Type': 'application/json'
               //      }
               // });
               const actualData = await res.json();
               setAPIData(actualData.data);
               setCount(actualData.data.length);
          } catch (error) {
               console.log('Error', error);
          } finally {
               setLoading(false);
          }
     }
     const TableData = apiData;
     useEffect(() => {
          getData();
     }, []);
   

     const [selectedFile, setSelectedFile] = useState(null);
     const [tableRowData, setTableRowData ] = useState(null)

     const handleFileChange = async (event, rowData) => {
          console.log("rowdata====",tableRowData);
          const file = event.target.files[0]
          const fileExtension = await getFileExtension(file.name);
        if (isValidFileExtension(fileExtension)) {
            setSelectedFile(file);
            console.log("file set");
          } else {
            // Invalid file format
            alert('Invalid file format. Please select a CSV, XLSX, or XLS file.');
          }
          // setSelectedFile(event.target.files[0]);
     };

     const getFileExtension = (filename) => {
          return filename.split('.').pop().toLowerCase();
     };
      
     const isValidFileExtension = (extension) => {
          const allowedExtensions = ['csv', 'xlsx', 'xls'];
          return allowedExtensions.includes(extension);
     };

     const handleUpload = async () => {
          console.log("func call");
          // Perform the upload logic here
          if (selectedFile && tableRowData) {
               const formData = new FormData();
               formData.append('file', selectedFile);
               formData.append('org_id', org_id);
               formData.append('user_email', user_email);

               // const response = await  axiosInstance.post(`http://127.0.0.1:8000/activity/master_upload_csv/`, formData)
               const response = await  axiosInstance.post(`https://api.projectivetech.com/activity/master_upload_csv/`, formData)
               console.log(response);
               alert('File successfully uploaded.');
               setSelectedFile(null)
               setTableRowData(null)
          }
     };

     useEffect(() => {
          if (selectedFile)
          handleUpload()
     }, [selectedFile])
     

     const actions = [
          {
            icon: icons.IconDownload,
            tooltip: 'Download',
            onClick: async (event, rowData) => {
               const urlWithoutParams = rowData.file_url.split("?")[0];
               const anchor = document.createElement('a');
               anchor.href = urlWithoutParams;
               anchor.download = getFileNameFromUrl(urlWithoutParams);
               anchor.click();
            }
          },
          {
            icon: icons.IconUpload,
            tooltip: 'Upload',
            onClick: async (event, rowData) => {
              // Trigger file input click
              setTableRowData(rowData)
              document.getElementById('fileInput').click();
          //     await handleUpload(rowData);
            }
          }
     ];

     const getFileNameFromUrl = (url) => {
          const urlParts = url.split('/');
          return urlParts[urlParts.length - 1];
     };


     return (
          <>
               {/* <MainCard style={{ padding: '0px', marginBottom: '10px' }}>
                    <Grid container spacing={gridSpacing} style={{ padding: '0px' }}>
                         <div className="re_topBar">
                              <ul>


                                   <Link to="/passive-tyres" className="re_topBar_Link">
                                        <img style={{ height: '20px', width: '20px', marginTop: '28px', marginRight: '10px', marginLeft: '0px' }} src={tt} alt="wsd" />
                                        <li className="re_topBar_Link_li_2">
                                             Passive Tyres
                                        </li>
                                   </Link>

                                   <Link to="/active-tyres" className="re_topBar_Link">
                                        <img style={{ height: '20px', width: '20px', marginTop: '28px', marginRight: '10px', marginLeft: '35px' }} src={pulse} alt="wsd" />
                                        <li className="re_topBar_Link_li_3">
                                             Active Tyres
                                        </li>
                                   </Link>

                                   <Link to="/vehicle-running-report-and-billing" className="re_topBar_Link">
                                        <img style={{ height: '20px', width: '20px', marginTop: '28px', marginRight: '10px', marginLeft: '35px' }} src={bill} alt="wsd" />
                                        <li className="re_topBar_Link_li_4">
                                             Vehicle Running & Billing
                                        </li>
                                   </Link>


                                   <Link to="/removed-tyres" className="re_topBar_Link">
                                        <img style={{ height: '20px', width: '20px', marginTop: '28px', marginRight: '10px', marginLeft: '35px' }} src={bin} alt="wsd" />
                                        <li className="re_topBar_Link_li_5__q">
                                             Removed Tyres
                                        </li>
                                   </Link>


                                   <Link to="/Casing/Damage-Report" className="re_topBar_Link">
                                        <img style={{ height: '20px', width: '20px', marginTop: '28px', marginRight: '10px', marginLeft: '35px' }} src={damage} alt="wsd" />
                                        <li className="re_topBar_Link_li_5">
                                             Casing/Damage/Exit Tyre
                                        </li>
                                   </Link>

                              </ul>
                         </div>
                    </Grid>
               </MainCard> */}

               <MainCard title="Master" secondary={<SecondaryAction />}>
                    {/* <Grid container spacing={gridSpacing}>
                         <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid">
                              <Grid lg={3} sm={6} className="sad_Single">
                                   <Label>Select Fleet</Label>
                                   <select ref={inputRef} onChange={(e) => setFleetName(e.target.value)} className="form-select  fleetSlect">
                                        <option className="options" value={''}>All Fleets</option>
                                        {allFleetName.map((item) => {
                                             return (<>
                                                  <option value={item.fields.fleet_name}>
                                                       {item.fields.fleet_name}
                                                  </option>
                                             </>)
                                        })}
                                   </select>
                              </Grid>

                              <Grid lg={3} md={3} sm={6} className="sad_Single2">
                                   <Label>Select Pattern</Label>
                                   <select onChange={(e) => setPattern(e.target.value)} className="form-select fleetSlect">
                                        <option value={''}>All Pattern</option>
                                        {uniquePattern.map((item) => {
                                             return (<>
                                                  <option value={item.tyre_pattern}>
                                                       {item.tyre_pattern}
                                                  </option>
                                             </>)
                                        })}
                                   </select>
                              </Grid>



                              <Grid lg={3} md={3} sm={6} className="sad_Single2">
                                   <Label>Select Size</Label>
                                   <select onChange={(e) => setSize(e.target.value)} className="form-select fleetSlect">
                                        <option value={''}>All Size</option>
                                        {uniqueSize.map((item) => {
                                             return (<>
                                                  <option value={item.tyre_size}>
                                                       {item.tyre_size}
                                                  </option>
                                             </>)
                                        })}



                                   </select>
                              </Grid>


                              <Grid lg={3} md={3} sm={6} className="sad_Single2">
                                   <Label>All Category </Label>
                                   <select onChange={(e) => setCategory(e.target.value)} className="form-select fleetSlect">
                                        <option value={''}> All Category</option>
                                        {uniqueCategory.map((item) => {
                                             return (<>
                                                  <option value={item.Exit_tyre_Category}>
                                                       {item.Exit_tyre_Category}
                                                  </option>
                                             </>)
                                        })}
                                   </select>
                              </Grid>

                         </Grid>




                         <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid">
                              <Grid lg={3} sm={6} className="sadlllllll">
                                   <Label style={{ marginLeft: '20px' }}>Removal Date</Label>
                                   <Flatpickr
                                        style={{ marginLeft: '20px' }}
                                        className="form-control fp_w-alp"
                                        placeholder={'Select Start Date'}
                                        ref={refComp1}
                                        options={optionStartDate}

                                   />
                              </Grid>

                              <Grid lg={3} sm={6} className="sadlllllll2">
                                   <Label style={{ marginLeft: '20px' }}>Removal Date</Label>
                                   <Flatpickr
                                        style={{ marginLeft: '20px' }}
                                        className="form-control fp_w-alp"
                                        placeholder={'Select End Date'}
                                        ref={refComp2}
                                        options={optionEndDate}
                                   />
                              </Grid>



                              <Grid lg={3} sm={6}>
                                   <br></br>
                                   <button className="fp_w_alp__vrb__button" style={{ marginLeft: '30px', marginTop: '10px' }} onClick={fetchedFilterData}>Fetch Data</button>
                              </Grid>


                              <Grid lg={3} sm={6}>
                                   <br></br>
                                   <button className="fp_w_alp__vrb__button" style={{ marginLeft: '30px', marginTop: '10px' }} onClick={resetFilterData}>Reset Filters</button>

                              </Grid>


                         </Grid>


                    </Grid> */}
                    <input
                         type="file"
                         id="fileInput"
                         onChange={handleFileChange}
                         style={{ display: 'none' }}
                    />
                    <Grid container spacing={gridSpacing}>
                         <Grid item lg={12} sm={12} md={12} className="hiddenscrollDiv" style={{ maxWidth: '100%', width: '100%', overflowX: 'scroll' }}>
                              <MaterialTable
                                   actions={actions}
                                   isLoading={loading}
                                   title={"Master Data"}
                                   columns={columns}
                                   data={TableData}
                                   // data={[
                                   //      { file_name: 'Mehmet', file_url: 'Baran', birthYear: 1987, birthCity: 63 },
                                   //      { file_name: 'Zerya Betül', file_url: 'Baran', birthYear: 2017, birthCity: 34 },
                                   //    ]}
                                   options={{
                                        pageSize: 6,
                                        actionsColumnIndex: 0,
                                        search: false,
                                        grouping: false,
                                        columnsButton: false,
                                        paging: true,
                                        showFirstLastPageButtons: false,
                                        filtering: false,
                                        // exportMenu: [
                                        //      {
                                        //           label: "Export PDF",
                                        //           exportFunc: (cols, datas) =>
                                        //                ExportPdf(cols, datas, "myPdfFileName"),
                                        //      },
                                        //      {
                                        //           label: "Export CSV",
                                        //           exportFunc: (cols, datas) =>
                                        //                ExportCsv(cols, datas, "myCsvFileName"),
                                        //      },
                                        // ],
                                        headerStyle: {
                                             backgroundColor: "rgba(173, 216, 230, 0.281)",
                                             color: "black",
                                             width: "100vw",
                                             height: "80px",
                                             textAlign: "left",
                                             fontSize: "13px",
                                             fontWeight: "bolder",
                                             // borderLeft: '1px solid #bcbcbc',
                                             // borderRight: '1px solid #bcbcbc',
                                             // borderTop: '1px solid #bcbcbc'

                                        },
                                        cellStyle: {
                                             textAlign: "left",
                                             color: 'black',
                                             fontSize: '12px',
                                             fontWeight: "bolder",
                                             // borderLeft: '1px solid #bcbcbc',
                                             // borderRight: '1px solid #bcbcbc',

                                        },
                                   }}

                              />
                              <br></br> <br></br>


                         </Grid>
                    </Grid>
               </MainCard>

               <Grid item xs={12} className="sub_div">
                    <Grid container spacing={gridSpacing}>
                         <Grid item lg={12} md={6} sm={6} xs={12}>
                              <Grid className="col-12 col-sm-12 text-center footer_inner_div">
                                   &copy; {new Date().getFullYear()} IMAGE-I 
                              </Grid>
                         </Grid>
                    </Grid>
               </Grid>
          </>
     )
}

export default Master